<!-- 用户功能 - 重置密码成功 -->
<template>
  <div>
    <div class="Reset-content">
      <div class="Reset-content-tab" v-if="query.status=='success'">
        <!-- Success Start -->
        <img src="../../assets/user/Success.png">
        <h3>{{query.message}}</h3>
        <p>{{index}}秒后自动跳转到首页，若未跳转，可<a href="javascript:;" @click="Jump">点击跳转</a></p>
        <!-- Success End -->
      </div>
      <div class="Reset-content-tab" v-else>
        <!-- Success Start -->
        <img src="../../assets/user/error.png">
        <h3>{{query.message}}</h3>
        <p>{{index}}秒后自动跳转到首页，若未跳转，可<a href="javascript:;" @click="Jump">点击跳转</a></p>
        <!-- Success End -->
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        index: 5,
        query: {}
      }
    },
    mounted () {
      var timer = 1000;
      let params = this.$queryUrlParams();
//      let params = decodeURI(this.$queryUrlParams());
      params.message = decodeURIComponent(params.message);

      this.query = params;

      var intervalNum = setInterval(()=>{
        this.index--;
        if(this.index <= 0){
          clearInterval(intervalNum);
          this.$router.push('/');
        }
      },timer);
    },
    methods: {
      Jump () {
        this.$router.push('/');
      }
    }
  }
</script>
<style scoped>
  .clearfix:after{
    content:".";
    display:block;
    height:0;
    clear:both;
    visibility:hidden
  }
  .clearfix{
    *+height:1%;
  }
  /*Content Start*/
  .Reset-content{
    width: 640px;
    height: 400px;
    margin: 35px auto 0 auto;
    text-align: center;
  }
  .Reset-content > .Reset-content-title{
    height: 60px;
  }
  .Reset-content-tab > img{
    margin-top:70px;
  }
  .Reset-content-tab > h3{
    margin-top:30px;
  }
  .Reset-content-tab > p{
    margin-top:50px;
  }
  /*title Start*/
  .Reset-content-title > ul > li {
    width:33.3%;
    float: left;
    text-align: center;
  }
  .Reset-content-title > ul > .active{
    color:#b71d2a;
  }
  .line{
    width:640px;
    height:15px;
    border-bottom: solid 1px #d0d0d0;
    position: relative;
    margin-top:5px;
  }
  .line > span{
    width:12px;
    height:12px;
    border-radius: 50%;
    background-color: #b71d2a;
    position: absolute;
    bottom: -7px;
  }
  .line > span:nth-child(1){
    left:100px;
    /*top:0;*/
  }
  .line > span:nth-child(2){
    left:50%;
    /*top:0;*/
    transform:translate(-50%,0);
  }
  .line > span:nth-child(3){
    right:100px;
    /*top:0;*/
  }
  /*title End*/
  .Reset-content > .Reset-content-tab{
    width: 370px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// CommonResult.vue?1793c4ca